import { Injectable } from '@angular/core';
import { Metadata, OptionItem } from '@classifieds-sell/datalayer';
import { RouterFacade } from '@classifieds-sell/state';
import { getDifferenceDays } from '../helpers/date.helper';

@Injectable()
export class ListingDurationService {
    private _isEditPage: boolean | null = null;
    constructor(router: RouterFacade) {
        // remember router state internally
        // as detecting isEditPage happens early than any UI is rendered
        router.isEditPage$.subscribe((isEditPage) => {
            this._isEditPage = isEditPage;
        });
    }

    public getDurationItems(metadata: Metadata): OptionItem[] {
        if (this._isEditPage) {
            // relistDate is only populated on relisted listings
            // if it is present use it to calculate the duration
            // otherwise use the listingStartDate
            const initialDate =
                metadata.listingRelistDate || metadata.listingStartDate;
            const dayDiff = getDifferenceDays(
                new Date(initialDate),
                new Date()
            );
            return [...metadata.duration.filter((x) => x.value > dayDiff)];
        }
        return [...metadata.duration];
    }

    /**
     * @description this is availableDateText for legacy reasons, it will calculate listingEndDate
     * on create/edit/relist flows, it should be called listingEndDateText
     * @param metatable
     * @param duration
     * @returns
     */
    public availableDateText(metatable: Metadata, duration: number): Date {
        if (metatable.isUntilWithdrawn) {
            const maxDuration = Math.max(...metatable.duration.map(x => x.value));
            const date = new Date();
            date.setDate(date.getDate() + maxDuration);
            return date;
        }

        if (!duration) {
            return new Date(metatable.listingEndDate);
        }

        const initialDateData =
            metatable.listingRelistDate || metatable.listingStartDate;
        const initialDate = new Date(initialDateData);
        const startDate = this._isEditPage ? initialDate : new Date();
        // update startDate with duration
        startDate.setDate(startDate.getDate() + duration);
        return startDate;
    }
}
